/* eslint-disable react/no-danger */
import * as React from 'react';

import type { CannedCollectionModuleCard } from '@coursera-web/cds-labs';

import { clearEmptyFields } from 'bundles/seo/utils/utils';

type Props = {
  headline?: string | null;
  description?: string | null;
  cards: CannedCollectionModuleCard[];
};
const CannedCollectionsSchemaMarkup = ({ cards, headline, description }: Props) => {
  const markupJson = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    name: headline,
    description,
    numberOfItems: cards.length,
    itemListElement: cards.map((card, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: card.headline,
      description: card.body,
      image: card.cardBackgroundImage?.url,
      url: card.target,
    })),
  };

  const createMarkup = () => ({
    __html: `
      <script type="application/ld+json">
        ${JSON.stringify(clearEmptyFields(markupJson))}
      </script>
    `,
  });

  return (
    <div className="rc-CannedCollectionsSchemaMarkup">
      <div dangerouslySetInnerHTML={createMarkup()} />
    </div>
  );
};

export default CannedCollectionsSchemaMarkup;
